export type BiddingPostStatusCategory = 'new' | 'in_progress' | 'completed' | 'other';

export interface BiddingPostStatusLike {
  name?: string | null;
  code?: string | null;
}

export const getBiddingPostStatusCategory = (
  status?: BiddingPostStatusLike | null
): BiddingPostStatusCategory => {
  if (!status) return 'other';

  const code = (status.code || '').trim().toUpperCase();

  // Published / New in backend -> Blue
  if (code === 'PUBLISHED' || code === 'NEW') {
    return 'new';
  }

  // Ongoing / In Progress in backend -> Orange
  if (code === 'ONGOING' || code === 'IN_PROGRESS') {
    return 'in_progress';
  }

  // Completed in backend -> Green
  if (code === 'COMPLETED') {
    return 'completed';
  }

  return 'other';
};

export const getBiddingPostStatusChipType = (
  status?: BiddingPostStatusLike | null
): 'primary' | 'warning' | 'success' | 'default' => {
  const category = getBiddingPostStatusCategory(status);
  switch (category) {
    case 'new':
      return 'primary';
    case 'in_progress':
      return 'warning';
    case 'completed':
      return 'success';
    default:
      return 'default';
  }
};
